/**
 * Shared constants used across FDC and Gun Commander pages.
 * Single source of truth — avoids duplication between components.
 */

export const GUN_NUMBERS = [1, 2, 3, 4, 5, 6];

export const GUN_OPTIONS = GUN_NUMBERS.map((n) => ({
  value: String(n),
  label: `Gun ${n}`,
}));

export const WEAPONS = ["M109", "M114", "M119"];

export const CHARGE_OPTIONS_BY_WEAPON = {
  // M109 green-bag (G) 3-5, white-bag (W) 3-7, charge 8, and 7R — full MT4-306 set.
  M109: ["3gb", "4gb", "5gb", "3wb", "4wb", "5wb", "6wb", "7wb", "8", "7r"],
  M114: ["3wb", "3gb", "4gb", "4wb"],
  M119: ["1", "2", "3"],
};

export const DEFAULT_CHARGES = ["3wb", "3gb", "4gb", "4wb"];

export const getChargeOptions = (weapon) =>
  CHARGE_OPTIONS_BY_WEAPON[weapon] || DEFAULT_CHARGES;

export const DEFAULT_MGRS_ZONE =
  process.env.REACT_APP_MGRS_ZONE_DEFAULT || "29SND";

// Backend (API) base URL — resolved at RUNTIME, not baked at build time, so the
// same bundle works whether it is served by the FDC itself (same origin) or run as
// a standalone gun client pointed at a remote FDC.
//   1. explicit operator override (config panel) -> localStorage "chacal_backend_url"
//   2. build-time REACT_APP_BACKEND_URL (dev convenience)
//   3. same origin as the page + "/api"  (normal field case: open http://<fdc>:8090)
export const BACKEND_OVERRIDE_KEY = "chacal_backend_url";

export function resolveBackendUrl() {
  try {
    const override = (localStorage.getItem(BACKEND_OVERRIDE_KEY) || "").trim();
    if (override) return override.replace(/\/+$/, "");
  } catch (e) {
    /* localStorage unavailable */
  }
  if (process.env.REACT_APP_BACKEND_URL) return process.env.REACT_APP_BACKEND_URL;
  if (typeof window !== "undefined" && window.location && window.location.origin) {
    return `${window.location.origin}/api`;
  }
  return "/api";
}

export function setBackendOverride(url) {
  const v = (url || "").trim().replace(/\/+$/, "");
  try {
    if (v) localStorage.setItem(BACKEND_OVERRIDE_KEY, v);
    else localStorage.removeItem(BACKEND_OVERRIDE_KEY);
  } catch (e) {
    /* ignore */
  }
}

export function getBackendOverride() {
  try {
    return localStorage.getItem(BACKEND_OVERRIDE_KEY) || "";
  } catch (e) {
    return "";
  }
}

export const BACKEND_URL = resolveBackendUrl();
